import { InvestmentTransactionType } from "hooks/investments/GetInvestmentTransactionsHook";
import {
  TYPE_LABELS,
  formatDate,
  formatNumber,
  FileCell,
  DotsMenu,
} from "./tableUtils";

interface PreciousStonesTableProps {
  transactions: InvestmentTransactionType[];
  item: any | null;
  isOwn?: boolean;
  onEditTx?: (tx: InvestmentTransactionType) => void;
}

const PreciousStonesTable = ({
  transactions,
  item,
  isOwn = false,
  onEditTx,
}: PreciousStonesTableProps) => {
  const firstBuyDate = transactions
    .filter((tx) => tx.type === "buy")
    .map((tx) => tx.completedAt ?? tx.createdAt)
    .sort()[0];

  console.log(item, "poka");
  return (
    <table className="itm-table">
      <thead>
        <tr>
          <th>Transakcja</th>
          <th>Cena zakupu</th>
          <th>Data</th>
          <th>Masa</th>
          <th>Szlif</th>
          <th>Barwa</th>
          <th>Czystość</th>
          <th>
            Data pierwszego <br /> zakupu Kamieni <br /> szlachetnych
          </th>
          <th>Umowa</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {transactions.map((tx) => (
          <tr key={tx.uuid}>
            <td>{TYPE_LABELS[tx.type] ?? tx.type}</td>
            <td>{formatNumber(tx.totalValue)}</td>
            <td>{formatDate(tx.completedAt ?? tx.createdAt)}</td>
            <td>
              {tx.quantity != null
                ? `${tx.type === "buy" ? "+" : "-"}${tx.quantity}g`
                : "Brak"}
            </td>
            <td>{item?.details?.cut ?? "Brak"}</td>
            <td>{item?.details?.color ?? "Brak"}</td>
            <td>{item?.details?.clarity ?? "Brak"}</td>
            <td>{formatDate(firstBuyDate)}</td>
            <td>
              <FileCell tx={tx} />
            </td>
            <td>
              <DotsMenu
                tx={tx}
                onEdit={
                  isOwn || tx.type === "sell" ? () => onEditTx?.(tx) : undefined
                }
              />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default PreciousStonesTable;
